<template>
  <div
    class="modal right fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            &times;
          </button>
          <h6 class="modal-title" id="myModalLabel">Carrito ({{ cartProducts.length }}) Items</h6>
        </div>
        <div class="modal-body">
          <template v-if="cartProducts.length > 0">
            <div
              class="col-sm-12 text-center"
              style="padding-top: 20px; border: #ced7df 2px dotted;"
              v-for="(item, index) in cartProducts"
              :key="index"
            >
              <div class="row">
                <div class="col-sm-12">
                  <img
                    class="imagen-cover"
                    v-bind:src="imgPreUrl + item.photo_product + '.jpg'"
                    alt="Card image cap"
                  />
                </div>
                <template v-if="item.subproduct.id_lote == 0">
                  <div class="col-sm-12">
                    <p>
                      <strong>{{ item.name_product_es }}</strong>
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-12">
                    <p>
                      <strong>{{
                        item.name_product_es + ' Sub-product SKU: ' + item.subproduct.lote_sku
                      }}</strong>
                    </p>
                  </div>
                </template>

                <div class="col-sm-12">
                  <small style="color:red;">{{ item.price_product | currency }}</small
                  ><small>
                    x
                    <span class="span-cantidad-calculator"
                      ><strong>{{ item.qty }}</strong></span
                    >
                  </small>
                </div>
                <div class="col-sm-12">
                  <small>Subtotal:</small>
                  <small style="color:red;">
                    {{
                      (Math.round((item.price_product / 1.18) * (item.qty * 1.18) * 100) / 100.0)
                        | currency
                    }}</small
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="error-template container">
              <h2>Su carrito está vacío</h2>
              <div class="error-details">Agrega productos ahora >></div>
              <div class="error-actions">
                <router-link to="/productos" data-dismiss="modal">Seguir comprando</router-link>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-12">
              <router-link
                tag="button"
                class="btn-al btn-al-md btn-al-celeste-solid btn-ancho-total"
                data-dismiss="modal"
                id="button"
                to="/carrito"
                ><small>Ir al Carrito</small> <i class="fa fa-shopping-cart"></i
              ></router-link>
            </div>
            <div class="col-sm-12">
              <br />
            </div>
            <div class="col-sm-12">
              <button
                type="button"
                class="btn-al btn-al-md btn-al-azul-solid btn-ancho-total"
                data-dismiss="modal"
                id="button"
              >
                <small>Seguir Comprando</small> <i class="fa fa-shopping-cart"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config_settings } from '@/config.js';
import { mapState } from 'vuex';

export default {
  name: 'CartSidebar',
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  computed: mapState(['cartProducts']),
};
</script>
